import React from 'react';
import { InputField, InputSize } from '@ids/react-input-field';
// TODO :: Should use react component from IDS, but it requires react version upgrade
import ErrorMessage from '../../../ErrorMessage';

const TextInput = ({ onChange, value, name, error, label, isMandatory = false, placeholder, disabled, cssClasses }) => {
  return (
    <>
      <div className={cssClasses}>
        <label htmlFor={name}>{label}</label>
        <InputField
          name={name}
          inputSize={InputSize.SMALL}
          onChange={onChange}
          aria-label={label}
          value={value}
          invalid={isMandatory && (value?.trim()?.length === 0 || error?.length > 0)}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
        />
        <ErrorMessage message={error} />
      </div>
    </>
  );
};

export default TextInput;
